import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root',
  })
  export class SharedService {
    currentURL:Subject<string> = new Subject<string>();
  }